import React from 'react'
import t from 'prop-types'
import Offset from '../../Layouts/Offset'

const PillarChapterHeader = ({ data }) => {
  const HeadTag = `${data.tag}`
  return (
    <>
      <div
        className="mt-20 lg:mt-30 mb-16 lg:mb‰-20"
        id={data.slug + '-' + data.index}
        data-index={data.index}
      >
        <Offset direction={data.index % 2 === 0 ? 'left' : 'right'}>
          <div className={`bg-blue-200 text-white px-5 md:px-10 lg:px-24`}>
            <Offset direction={data.index % 2 === 0 ? 'right' : 'left'}>
              <div className="max-w-screen-md mx-auto py-16 lg:py-20">
                <div className="text-xs md:text-sm lg:text-base leading-tight tracking-spacious font-medium uppercase mb-4">
                  {data.label} {data.index}
                </div>
                <HeadTag className="font-serif font-semibold text-4xl lg:text-5xl">
                  {data.text}
                </HeadTag>
              </div>
            </Offset>
          </div>
        </Offset>
      </div>
    </>
  )
}

PillarChapterHeader.propTypes = {
  data: t.object,
}

PillarChapterHeader.defaultProps = {
  data: {},
}

export default PillarChapterHeader
